import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  selectBlockApiActionLoading,
  selectSelectedBlockApiApiKey,
  selectShowBlockApiEditorModal,
  handleHideBlockApiEditorModal,
  createBlockApiApiKeyAsync,
  updateBlockApiApiKeyAsync,
  getBlockApiApiKeysAysnc,
} from "../../../store/block-api/apiKeysSlice";
import { BlockApiApiKeySchema } from "../../../utils/validations";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { useCallback, useEffect } from "react";
import { Button, Input, Modal } from "djuno-design";

const ApiKeyEditorModal = () => {
  const isOpen = useAppSelector(selectShowBlockApiEditorModal);
  const loading = useAppSelector(selectBlockApiActionLoading);
  const apiKey = useAppSelector(selectSelectedBlockApiApiKey);
  const dispatch = useAppDispatch();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(BlockApiApiKeySchema),
  });

  useEffect(() => {
    if (isOpen && apiKey) {
      setValue("label", apiKey.Label);
    }
  }, [isOpen, apiKey, setValue]);

  const onSubmit = (data: any) => {
    if (apiKey) {
      dispatch(
        updateBlockApiApiKeyAsync({
          id: apiKey.Id,
          formData: {
            label: data.label,
          },
        })
      ).then((action) => {
        if (action.type === "block-api/api-keys/update/fulfilled") {
          reset();
          dispatch(handleHideBlockApiEditorModal());
          dispatch(getBlockApiApiKeysAysnc());
        }
      });
    } else {
      dispatch(
        createBlockApiApiKeyAsync({
          label: data.label,
        })
      ).then((action) => {
        if (action.type === "block-api/api-keys/create/fulfilled") {
          reset();
          dispatch(handleHideBlockApiEditorModal());
          dispatch(getBlockApiApiKeysAysnc());
        }
      });
    }
  };

  const handleOnClose = useCallback(() => {
    dispatch(handleHideBlockApiEditorModal());
    reset();
  }, [dispatch, reset]);

  useEffect(() => {
    return () => {
      handleOnClose();
    };
  }, [handleOnClose]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleOnClose}
      contentClassName="max-w-lg"
      //   containerClassName="!items-start"
      title={apiKey ? "Update api key" : "Create new api key"}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="mt-5 flex flex-col w-full gap-5">
          <Input
            label="API key label"
            {...register("label")}
            error={errors.label?.message}
            placeholder=""
            required
          />
        </div>
        <div className="mt-4 flex justify-end">
          <Button
            loading={loading}
            uiType="primary"
            disabled={loading}
            type="submit"
            // buttonClassName="w-[100px]"
          >
            {apiKey ? "Update" : "Create"}
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default ApiKeyEditorModal;
